import React, { PropTypes, Children } from 'react'
import CSSModules from 'react-css-modules'

import Label from 'components/grid-form-label'

import styles from './grid-form-field.css'

const GridFormField = ({ children, field, label, border, optional }) => (
  <div styleName={border ? 'field-border' : 'field-no-border'}>
    <Label name={label} optional={optional} field={field} />
    {Children.map(children, child => React.cloneElement(child, { field }))}
  </div>
)

GridFormField.propTypes = {
  border: PropTypes.bool,
  children: PropTypes.any,
  field: PropTypes.object,
  label: PropTypes.string,
  optional: PropTypes.string,
}

export default CSSModules(GridFormField, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid-form-field/grid-form-field.js
 **/